module.exports = __webpack_public_path__ + "img/map-dark.4421532c.svg";